import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Companies,
  Dashboard,
  DashboardAdmin,
  Drivers,
  Freights,
  Import,
  ReasonsRefusal,
  Reprocessing,
  Settings,
  Vehicles,
  VehicleTypes,
} from '..';
import { Drawer } from '../../components';
import { useStyles } from '../../services/material-ui';
import PaymentOrders from '../PaymentOrders';
import PaymentOrderGroups from '../PaymentOrderGroups';
import Configurations from '../Configurations';
import UsersAdmin from '../UsersAdmin';
import PrivateDrivers from '../PrivateDrivers';
import PrivateVehicles from '../PrivateVehicles';

const Home: React.FC = () => {
  const history = useHistory();
  const actualRoute = window.location.pathname.substring(1).split('/')[1];
  const classes = useStyles();

  const RenderContentPage = useMemo(() => {
    switch (actualRoute) {
      case 'dashboard-admin':
        return <DashboardAdmin />;
      case 'dashboard':
        return <Dashboard />;
      case 'drivers':
        return <Drivers />;
      case 'private-drivers':
        return <PrivateDrivers />;
      case 'private-vehicles':
        return <PrivateVehicles />;
      case 'shippings':
        return <Freights />;
      case 'reprocessing':
        return <Reprocessing />;
      case 'vehicle-types':
        return <VehicleTypes />;
      case 'vehicles':
        return <Vehicles />;
      case 'users-admin':
        return <UsersAdmin />;
      case 'companies':
        return <Companies />;
      case 'settings':
        return <Settings />;
      case 'import':
        return <Import />;
      case 'reasons-refusal':
        return <ReasonsRefusal />;
      case 'payment-orders':
        return <PaymentOrders />;
      case 'payment-order-groups':
        return <PaymentOrderGroups />;
      case 'configurations':
        return <Configurations />;
      default:
        history.push('/home/dashboard-admin');
        return <h5>Rota inexistente</h5>;
    }
  }, [actualRoute, history]);

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>{RenderContentPage}</main>
    </div>
  );
};

export default Home;
